import script from "./ThankYou.vue?vue&type=script&setup=true&lang=js"
export * from "./ThankYou.vue?vue&type=script&setup=true&lang=js"

import "./ThankYou.vue?vue&type=style&index=0&id=1022e2fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1022e2fc"]])

export default __exports__